import { useQuery } from "react-query";

import { useCourses } from "~/entity/Courses";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

const courseLevelsQueryKey = ["courseLevels"] as const;

const useCourseLevelsSelectOptions = () => {
  const { getLevels } = useCourses();
  const actualOn = dateFormat(new Date(), { type: "date-special" });

  const levelsQuery = useQuery({
    queryKey: [...courseLevelsQueryKey, actualOn],
    queryFn: () =>
      getLevels({ actualOn, statuses: ["active" as const] }).then(({ data }) =>
        (data?.levels ?? []).map(({ name, instanceId }) => ({
          label: name,
          value: instanceId,
        })),
      ),
  });

  const levelsSelectOptions: { label: string; value: number }[] =
    levelsQuery.data ?? [];
  const levelsHashMap = levelsSelectOptions.reduce((acc, val) => {
    return {
      ...acc,
      [val.value]: val,
    };
  }, {});

  return {
    levelsSelectOptions,
    levelsHashMap,
    isLoading: levelsQuery.isLoading,
    isError: levelsQuery.isError,
  };
};

export default useCourseLevelsSelectOptions;
